import React, { useState, useEffect, useRef } from "react";

export const ParallaxImage = ({ imageUrl }) => {
  const [offsetY, setOffsetY] = useState(0);
  const imageRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (imageRef.current) {
        const rect = imageRef.current.getBoundingClientRect();
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const elementOffsetTop = scrollTop + rect.top;
        const windowHeight = window.innerHeight;

        // Solo mover la imagen si está visible en la ventana
        if (scrollTop + windowHeight > elementOffsetTop && scrollTop < elementOffsetTop + rect.height) {
          const parallaxOffset = (scrollTop - elementOffsetTop) * 0.2; // Ajusta el factor aquí para menos movimiento
          setOffsetY(parallaxOffset);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const styles = {
    container: {
      position: "relative",
      width: "100%",
      height: "100vh",
      overflow: "hidden",
      backgroundImage: `url(${imageUrl})`,
      backgroundPosition: `center ${offsetY}px`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      zIndex: 0,
    },
  };

  return <div ref={imageRef} style={styles.container}></div>;
};
